module.exports = __webpack_public_path__ + "static/media/twitter.7d12749b.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/twitter.svg
// module id = 1294
// module chunks = 0